import { css } from '@emotion/react';

export const WaterfallTierConfigCardCss = css`
  display: grid;
  grid-template-columns: min-content min-content auto;
  align-items: center;
  gap: 0.5rem;
  & > button:last-of-type {
    justify-self: end;
  }
  &&& input.MuiInputBase-input {
    color: var(--mui-palette-secondary-main);
    font-size: 1rem;
    font-weight: 500;
    @supports (field-sizing: content) {
      field-sizing: content;
    }
  }
`;
